/***************************************
 CREATED BY : Vekanth
 Last Modified Date : 26/06/2018
**************************************/

import { Component, OnInit, OnDestroy, Input, ElementRef, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, FormControl } from '@angular/forms';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { Subject, Observable } from 'rxjs';
import { SecureStorageService } from '../../secure-storage.service';
import { AutoComplete } from 'primeng/autocomplete';

const DEFAULT_DISTANCE = { id: 25, value: '25 miles' };

@Component({
    selector: 'app-providersearchpanel',
    templateUrl: './providersearchpanel.component.html',
    styleUrls: ['./providersearchpanel.component.css'],
    standalone: false
})
export class ProviderSearchPanelComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('zipAutoComplete') zipAutoComplete: AutoComplete;
  @Input() clearBtnView: string;
  @Input() maintainSearchState = true;
  @Input() fromAuthScreens: boolean;
  @Input() memberZipCode: string;
  @Input() memberUid: number;
  public regionData: any;
  public regionNeighborhoodData: any;

  @Input() set region(value: { id: number, value: string }) {
    if (this.fromAuthScreens && value && value.id) {
      this.providerSearchForm.get('providerIPAFormControl').patchValue(value);
      this.getNeighborhoodData(value.id);
      this.regionData = value;
    }
  }
  @Input() set neighborhood(value: { id: number, value: string }) {
    if (this.fromAuthScreens && value && value.id) {
      this.providerSearchForm.get('providerNeighborhoodFormControl').patchValue(value);
      this.getRegionData(value.id);
      this.regionNeighborhoodData = value;
    }
  }

  public providerSearchForm: UntypedFormGroup;
  public showProviderSearchError = false;
  public specialtyPlaceholder = 'Select Speciality';
  public regionPlaceholder = 'Select Region';
  public zipCodePlaceholder = 'Select ZIP CODE/CITY';
  public distancePlaceholder = 'Select distance (in miles)';
  public neighborhoodPlaceholder = 'Select Neighborhood';
  private neighborhoodSubscription: any;
  private regionSubscription: any;
  public zipCode: any;
  public providerName: String;
  public urlConstant: any = this.urlconstantsService.fetchUrl();

  public distanceInMiles: any[] = [];

  public IPADataList: any = [];
  public SpecialityList: any = [];
  public NeighborhoodList: any = [];
  public ZipCodeList: any[];
  private clearAllSubscription: any;
  private searchFilterSubscription: any;
  private geoCodeSubscription: any;
  public zipcodeSearchError = false;
  public milesDistance: string;
  // public specialtyTitle: string;
  public regionTitle: string;
  public neighborhoodTitle: string;
  public zipCodeTitle: string;
  public providerId: string;

  constructor(private fb: UntypedFormBuilder, elem: ElementRef, private cupService: CupService, private urlconstantsService: UrlconstantsService,
    private secureStorage:SecureStorageService) {

    this.createProviderForm();

    this.distanceInMiles = [
      { id: 2, value: '2 miles' }, { id: 5, value: '5 miles' }, { id: 10, value: '10 miles' },
      { id: 15, value: '15 miles' }, { id: 20, value: '20 miles' }, { id: 25, value: '25 miles' },
      { id: 30, value: '30 miles' }, { id: 40, value: '40 miles' }, { id: 50, value: '50 miles' },
      { id: 60, value: '60 miles' }, { id: 75, value: '75 miles' }, { id: 100, value: '100 miles' }];
    this.clearSubscription();
    this.searchFilterDataSubscription();
  }

  ngOnInit() {
    this.loadMetaDataForProviderSearch();
  }
  private clearSubscription() {
    this.clearAllSubscription = this.cupService.clearAll.subscribe(isClearAllClicked => {
      this.clearProviderData(isClearAllClicked);
    });
  }

  private searchFilterDataSubscription() {
    this.searchFilterSubscription = this.cupService.searchFilterData.subscribe(data => {
      if (data) {
        this.providerSearchForm.controls['providerIdFormControl'].patchValue(data.providerId);
        this.providerSearchForm.controls['providerNameFormControl'].patchValue(data.name);
        this.providerSearchForm.controls['providerOfficeNameFormControl'].patchValue(data.office);
        this.providerSearchForm.controls['providerCityFormControl'].patchValue(data.city);
        this.providerSearchForm.controls['providerSpecialtyFormControl'].patchValue(data.speciality);
        this.providerSearchForm.controls['providerIPAFormControl'].patchValue(data.ipa);
        this.providerSearchForm.controls['providerNeighborhoodFormControl'].patchValue(data.neighborhood);
        this.providerSearchForm.controls['providerDistanceFormControl'].patchValue(data.distance);
        this.providerSearchForm.controls['providerZipCodeFormControl'].patchValue(data.zipCodeAndCity);
      } else {
        this.clearProviderData();
      }
    });
  }

  private createProviderForm() {

    this.providerSearchForm = this.fb.group({
      providerIdFormControl: [''],
      providerNameFormControl: ['', Validators.compose([Validators.minLength(2)])],
      providerOfficeNameFormControl: [''],
      providerSpecialtyFormControl: [''],
      providerIPAFormControl: [''],
      providerZipCodeFormControl: [''],
      providerDistanceFormControl: [''],
      providerCityFormControl: [''],
      providerNeighborhoodFormControl: [''],
    });
  }

  /*Check for the GeoDistance*/
  public checkGeoDistance(event) {
    this.milesDistance = event ? event.value : '';
    const zipCodeCityVal = this.providerSearchForm.controls['providerZipCodeFormControl'].value;
    if (this.milesDistance && (zipCodeCityVal == null || zipCodeCityVal === '')) {
      this.zipcodeSearchError = true;
    } else {
      this.zipcodeSearchError = false;
    }
  }

  private loadMetaDataForProviderSearch() {
    this.cupService.isShowSpinner(true);

    if (!this.fromAuthScreens) {
      // IPA
      this.getRegionData();
    }

    // specialty
    this.cupService.retrieveData('get', this.urlConstant.specialty).subscribe(data => {
      this.SpecialityList = data;
    }, error => {
      this.cupService.isShowSpinner(false);
    });

    if (!this.fromAuthScreens) {
      // neighborhood
      this.getNeighborhoodData();
    }
    // zipcode
  }

  private getRegionData(neighborhoodUid?: number) {
    let getRegionURL = this.urlConstant.ipa;
    if (neighborhoodUid) {
      getRegionURL = this.urlConstant.regionByNeighborhood.replace('{neighborhooduid}', neighborhoodUid);
    }
    this.regionSubscription = this.cupService.retrieveData('get', getRegionURL).subscribe(data => {
      this.IPADataList = [];
      this.IPADataList = data;
    }, error => {
      this.cupService.isShowSpinner(false);
    });
  }

  private getNeighborhoodData(regionUid?: Number) {
    let neighborhoodURL = this.urlConstant.neighborhood;
    if (regionUid) {
      neighborhoodURL = this.urlConstant.neighborhoodByRegion.replace('{regionuid}', regionUid);
    }
    this.neighborhoodSubscription = this.cupService.retrieveData('get', neighborhoodURL).subscribe(data => {
      this.NeighborhoodList = [];
      this.NeighborhoodList = data;
      this.cupService.isShowSpinner(false);
    }, error => {
      this.cupService.isShowSpinner(false);
    });
  }
  /*Search*/
  public searchProviderData(formValues) {

    if (this.providerSearchForm.invalid) {
      this.cupService.isretainProviderPanelOnClick(true);
      return;
    }
    const specialityValue = this.providerSearchForm.controls.providerSpecialtyFormControl.value;
    const ipaValue = this.providerSearchForm.controls['providerIPAFormControl'].value;
    const neighborhoodValue = this.providerSearchForm.controls['providerNeighborhoodFormControl'].value;
    let zipCodeAndCityValue = this.providerSearchForm.controls['providerZipCodeFormControl'].value;
    if (zipCodeAndCityValue != null && typeof (zipCodeAndCityValue) === 'object') {
      zipCodeAndCityValue = zipCodeAndCityValue.zipCode;
    }

    const obj = {
      providerId: this.providerSearchForm.controls['providerIdFormControl'].value,
      name: this.providerSearchForm.controls['providerNameFormControl'].value,
      office: this.providerSearchForm.controls['providerOfficeNameFormControl'].value,
      city: this.providerSearchForm.controls['providerCityFormControl'].value,
      speciality: specialityValue,
      ipa: ipaValue,
      neighborhood: neighborhoodValue,
      distance:
        this.providerSearchForm.controls['providerDistanceFormControl'].value ?
          this.providerSearchForm.controls['providerDistanceFormControl'].value.id : '',
      zipCodeAndCity: zipCodeAndCityValue,
    };
    if (this.fromAuthScreens) {
      obj.distance = obj.distance ? obj.distance : DEFAULT_DISTANCE.id; // by default 25 miles for auth entry and auth update
    }
    const hasErrorInName = this.providerSearchForm.controls['providerNameFormControl'].hasError('pattern');
    if (this.fromAuthScreens) {
      if ((obj.providerId == null || obj.providerId === '') &&
        (obj.name === null || obj.name === '') &&
        (obj.speciality === null || obj.speciality === '') &&
        (obj.zipCodeAndCity === null || obj.zipCodeAndCity === '')) {
        this.showProviderSearchError = true;
      }
    } else {
      if ((obj.providerId === null || obj.providerId === '') &&
        (obj.name === null || obj.name === '') &&
        (obj.speciality == null || obj.speciality === '')) {
        this.showProviderSearchError = true;
      }
    }
    const checkMandatory = this.fromAuthScreens ? (obj.providerId ||
      obj.name ||
      obj.speciality ||
      obj.zipCodeAndCity) : (obj.providerId || obj.name || obj.speciality);
    if (checkMandatory && !this.zipcodeSearchError && !hasErrorInName) {
      this.showProviderSearchError = false;
      if (this.maintainSearchState) {
        this.secureStorage.setSecureInfoInSessionlStorage('providerResults', JSON.stringify(obj));
      }
      this.cupService.updateProviderSearchPanelDetails(true, obj);
      this.cupService.isretainProviderPanelOnClick(false);
    } else {
      this.cupService.isretainProviderPanelOnClick(true);
    }
  }

  /*Clear Search*/
  public clearProviderData(gridReset: boolean = true) {
    this.showProviderSearchError = false;
    this.zipcodeSearchError = false;
    this.milesDistance = '';
    // this.specialtyTitle = '';
    this.regionTitle = '';
    this.neighborhoodTitle = '';
    this.zipCodeTitle = '';
    this.providerSearchForm.reset();
    this.providerSearchForm.controls['providerZipCodeFormControl'].patchValue('');
    if (gridReset) {
      this.cupService.updateProviderSearchPanelDetails(false, null);
    }
    if (this.fromAuthScreens) {
      this.zipCode_ObservableSource(this.memberZipCode).subscribe(defaultZipCode => {
        if (defaultZipCode && defaultZipCode.length) {
          this.providerSearchForm.controls.providerZipCodeFormControl.patchValue(defaultZipCode[0].zipCode);
        }
        this.milesDistance = DEFAULT_DISTANCE.value;
        this.providerSearchForm.controls.providerDistanceFormControl.patchValue(DEFAULT_DISTANCE);
        this.providerSearchForm.get('providerIPAFormControl').patchValue(this.regionData);
        this.getNeighborhoodData(this.regionData.id);
        this.providerSearchForm.get('providerNeighborhoodFormControl').patchValue(this.regionNeighborhoodData);
        this.getRegionData(this.regionNeighborhoodData.id);
      });
    }
  }
  /*Clear icon for provider field*/
  public clearProviderName() {
    this.providerSearchForm.controls['providerNameFormControl'].reset();
  }

  /*Clear icon for provider Id field*/
  public clearProviderId() {
    this.providerSearchForm.controls['providerIdFormControl'].reset();
  }
  /*Clear icon for zipcode field*/
  private clearZipCode() {
    this.providerSearchForm.controls.providerZipCodeFormControl.reset();
    this.providerSearchForm.controls['providerZipCodeFormControl'].patchValue('');
    this.zipCodeTitle = '';
    // this.zipAutoComplete.inputEL.nativeElement.value='';
  }
  /*Retain Panel*/
  public retainOnInputClick() {
    this.cupService.isretainProviderPanelOnClick(true);
  }

  /*ZipCode Search*/
  zipCode_ObservableSource = (keyword: any): Observable<any[]> => {
    const resultData = new Subject<any>();
    const observerData = resultData.asObservable();
    const url = this.urlConstant.zipcode.replace('{zipcodecity}', keyword);

    this.cupService.retrieveData('get', url).subscribe(data => {
      if (data && data.length > 0) {
        resultData.next(data);
      } else {
        resultData.next([]);
      }
      resultData.complete();
    }, error => {
      resultData.next([]);
      resultData.complete();
    });
    return observerData;
  }

  /*On Change of values from corresponding dropdowns to determine title*/
  public onSpecialtyChange(specialty) {
    if (this.fromAuthScreens) {
      if (specialty && specialty.id) {
        let url: string = this.urlconstantsService.fetchUrl().providerGeocode.replace('{memberuid}', this.memberUid);
        url = url.replace('{specialtyuid}', specialty.id);
        this.cupService.isShowSpinner(true);
        this.geoCodeSubscription = this.cupService.retrieveData('get', url).subscribe(data => {
          try {
            if (data && data > 0) {
              const matchedDistance = this.distanceInMiles.find(distance => distance.id === data);
              if (matchedDistance) {
                this.providerSearchForm.get('providerDistanceFormControl').patchValue(matchedDistance);
                this.milesDistance = matchedDistance;
              }
            } else {
              this.providerSearchForm.get('providerDistanceFormControl').patchValue(DEFAULT_DISTANCE);
              this.milesDistance = DEFAULT_DISTANCE.value;
            }
            this.cupService.isShowSpinner(false);
          } catch (err) {
            this.cupService.isShowSpinner(false);
          }
        }, error => {
          this.cupService.isShowSpinner(false);
        });
      } else {
        this.providerSearchForm.get('providerDistanceFormControl').patchValue(DEFAULT_DISTANCE);
        this.milesDistance = DEFAULT_DISTANCE.value;
      }
    }
  }
  public onRegionChange(region) {
    const regionUid = region && typeof (region) === 'object' ? region.id : null;
    if (!regionUid) {
      this.providerSearchForm.get('providerNeighborhoodFormControl').patchValue(undefined);
      this.neighborhoodTitle = undefined;
      this.getRegionData();
    }
    this.getNeighborhoodData(regionUid);
    this.regionTitle = region ? region.value : '';
  }
  public onNeighborhoodChange(neighborhood) {
    const neighborhoodUid = neighborhood && typeof (neighborhood) === 'object' ? neighborhood.id : null;
    if (!neighborhoodUid) {
      this.providerSearchForm.get('providerIPAFormControl').patchValue(undefined);
      this.regionTitle = undefined;
      this.getNeighborhoodData();
    }
    this.getRegionData(neighborhoodUid);
    this.neighborhoodTitle = neighborhood ? neighborhood.value : '';
  }
  private onZipCodeChange(zipCode) {
    this.zipCodeTitle = zipCode ? zipCode.value : '';
  }
  ngOnDestroy() {
    this.clearAllSubscription.unsubscribe();
    this.searchFilterSubscription.unsubscribe();
    if (this.regionSubscription) {
      this.regionSubscription.unsubscribe();
    }
    if (this.neighborhoodSubscription) {
      this.neighborhoodSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.fromAuthScreens) {
      this.zipCode_ObservableSource(this.memberZipCode).subscribe(defaultZipCode => {
        if (defaultZipCode && defaultZipCode.length) {
          this.providerSearchForm.controls.providerZipCodeFormControl.patchValue(defaultZipCode[0].zipCode);
        }
        this.milesDistance = DEFAULT_DISTANCE.value;
        this.providerSearchForm.controls.providerDistanceFormControl.patchValue(DEFAULT_DISTANCE);
      });
    }
  }
}


